import angular from 'angular';
import textAngular from 'textangular';
import textangularConfig from './textangular.decorator';
import CommentSectionComponent from './comment-section.component';
import 'textangular/dist/textAngular.css';

export default angular
  .module('verifyApp.commentSection', [textAngular])
  .config(textangularConfig)
  .component('commentSection', CommentSectionComponent)
  .name;



// WEBPACK FOOTER //
// ./client/components/comment-section/index.js